import { InjectionToken } from '@angular/core';

import { PlatformSupplierDetailsTabPlugin } from '../interfaces';

export const PLATFORM_SUPPLIER_DETAILS_TAB_PLUGIN = new InjectionToken<PlatformSupplierDetailsTabPlugin[]>(
  'PlatformSupplierDetailsTabPlugin',
);
